import React, { useState } from 'react';

const ViewVideo = ({ videoUrl }) => {
    // const [videoUrl, setVideoUrl] = useState('');
    const [videoTitle, setVideoTitle] = useState('');

    // const handleVideoChange = (event) => {
    //     setVideoUrl(event.target.value);
    // };

    const handleTitleChange = (event) => {
        setVideoTitle(event.target.value);
    };

    return (
        <div className='video_cntnr'>
            <div className='video_plyr'>
                <video src={videoUrl} controls={{
                    controlsList: "nodownload"
                }} />
            </div>
        </div>
    );
};

export default ViewVideo;